export default __webpack_public_path__ + "static/media/auqui1.3ff3e540.jpg";